import React from "react";
import PropTypes from "prop-types";
import ReactQuill from "react-quill";
import { styled } from "@mui/material/styles";
import "react-quill/dist/quill.snow.css"; // Import Quill CSS

// Define the styles for the editor container
const RootStyle = styled("div")(({ theme }) => ({
  borderRadius: theme.shape.borderRadius,
  border: `solid 1px ${theme.palette.grey[500_32]}`,
  "& .ql-container.ql-snow": {
    borderColor: "transparent",
    ...theme.typography.body1,
    fontFamily: theme.typography.fontFamily,
  },
  "& .ql-editor": {
    minHeight: 200,
    "&.ql-blank::before": {
      fontStyle: "normal",
      color: theme.palette.text.disabled,
    },
  },
}));

// Define prop types for the component
QuillEditor.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  simple: PropTypes.bool,
  error: PropTypes.bool,
  sx: PropTypes.object,
};

// Main Editor Component
export default function QuillEditor({
  value,
  onChange,
  simple = false,
  error,
  sx,
  ...other
}) {
  // Define modules for the Quill editor, including toolbar options
  const modules = {
    toolbar: simple
      ? [
          ["bold", "italic", "underline"], // Basic toolbar for simple mode
          [{ list: "ordered" }, { list: "bullet" }],
          ["link"],
        ]
      : [
          [{ header: "1" }, { header: "2" }, { font: [] }],
          [{ list: "ordered" }, { list: "bullet" }],
          ["bold", "italic", "underline"],
          ["link", "image"],
        ],
  };

  return (
    <RootStyle
      sx={{
        ...(error && {
          border: (theme) => `solid 1px ${theme.palette.error.main}`,
        }),
        ...sx,
      }}
    >
      <ReactQuill
        value={value}
        onChange={onChange}
        modules={modules}
        formats={[
          "header",
          "font",
          "bold",
          "italic",
          "underline",
          "list",
          "bullet",
          "link",
          "image",
        ]}
        placeholder="Write something awesome..."
        {...other}
      />
    </RootStyle>
  );
}
